import { Backdrop, Button, CircularProgress, Container, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, MuiThemeProvider } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import SelectShedMovementType from '../../components/Form/SelectShedMovementType';
import ButtonUI from '../../components/ui/ButtonUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import { ConciergeSearch } from '../../interfaces/Concierge';
import { MvmShedRequest } from "../../interfaces/Mvm";
import MvmStatus from '../../interfaces/MvmStatus';
import MvmApi from '../../services/MvmApi';
import ShedApi from '../../services/ShedApi';
import { DataFormat } from '../../utils/componentUtils';
import MvmSummary from '../Mvm/components/MvmSummary';
import { useStyles } from './Style';

interface IFormInput {
    mvmNumber: any;
    id: number;
    invoices: any;
    name: string;
    rg: string;
    cpf: string;
    cnh: string;
    ajudantes: string;
    conciergeCode: any;
    shed: any;
    shedMovementType: any;
}

type Props = {
    setCheckinManual: (value: boolean) => void;
}

const opcoes = [
    { url: '/CheckIn', descricao: 'Registrar Nova Entrada', state: {} },
]

const CheckInManual: React.FC<Props> = (props) => {
    const classes = useStyles()
    const { user, hasPermission } = useAuth()
    const history = useHistory()
    const { t: _t } = useTranslation("General")
    const { t: tShed } = useTranslation("Shed");
    const { t: tval } = useTranslation("Validation");
    const { enqueueSnackbar } = useSnackbar();
    const [circularLoading, setCircularLoading] = useState(false)
    const [loading, setLoading] = useState(true);
    const [concierges, setConcierges] = useState<any>([]);
    const [mvm, setMvm] = useState<any>(null);
    const [conciergeCode, setConciergeCode] = useState<string>("");
    const { control, setValue, getValues, setError, clearErrors } = useForm<IFormInput>(
        {
            defaultValues: { mvmNumber: {}, conciergeCode: {}, shed: {}, shedMovementType: {} }
        })
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [shedId, setShedId] = React.useState(0);
    const [mvmId, setMvmId] = React.useState(0);
    const [sheds, setSheds] = React.useState<any>([]);
    const [shedList, setShedList] = React.useState<any>([]);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);

    const onSummaryChange = (data: any) => {
        if (!data) {
            setMvm(null);
            return
        }

        setSheds(data.sheds);
        setMvm(data);
        setValue("invoices", data.invoices);
        setValue("conciergeCode", { code: conciergeCode, label: conciergeCode });
    }

    useEffect(() => {
        //if (!hasPermission(permissions.MVM.RegisterEntry))
        //    history.replace('NoPermission');

        loadSheds();
    }, [history, user])

    const loadSheds = async () => {
        const result = await ShedApi.getShedListByUser(user.userName);
        setShedList(result)
    }

    const getConcierges = useCallback(
        async (data: ConciergeSearch) => {
            setLoading(true);

            MvmApi.searchConcierge(data)
                .then(result => {
                    if (result && result.items) {
                        setConcierges(result.items);
                    }
                    else {
                        setConcierges([]);
                    }
                }).catch(() => {
                    setConcierges([]);
                }).finally(() => {
                    setLoading(false);
                });

            let code = await MvmApi.userConcierge(user.userName, +user.company.plantID);
            setConciergeCode(code);
        },
        [],
    );

    useEffect(() => {

        let conciergeFilter: ConciergeSearch = {
            id: 0,
            code: "",
            plantId: Number(user.company.plantID),
            deleted: false,
            pageSize: 999
        };

        getConcierges(conciergeFilter);
    }, []);

    const handleDialogClickOpen = (idMvm: number, idShed: number) => {
        setMvmId(idMvm);
        setShedId(idShed);
        setDialogOpen(true);
    };

    const handleDialogClickClose = () => {
        setDialogOpen(false);
    };

    const handleConfirmation = async () => {
        setDialogOpen(false);
        setOpenBackdrop(true);

        MvmApi.shedCheckin(mvmId, [shedId])
            .then(async () => {
                enqueueSnackbar("CheckIn Realizado com Sucesso", { variant: 'success' });
                window.location.reload();
                setOpenBackdrop(false);

            }).catch(() => {
                setOpenBackdrop(false);
            });
    };

    const reloadShedList = async () => {
        const sheds_ = await MvmApi.getShedListById(mvm?.id);
        setSheds(sheds_);
    }

    const columns = [
        {
            style: { marginRight: "10px" },
            name: 'mvmId',
            label: " ",
            innerWidth: 10,
            options: {
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    if (sheds[tableMeta.rowIndex].checkInDate == null) {
                        var checkins = sheds.find((elem: { checkInDate: any, exitDate: any }) => {
                            return elem.checkInDate != null && elem.exitDate == null;
                        }
                        );

                        if (checkins == null || checkins == undefined || checkins.length == 0) {
                            return (
                                <Button
                                    variant="outlined"
                                    style={{
                                        height: "100%",
                                        width: "110%",
                                        fontSize: "0.7rem",
                                        padding: "2px",

                                    }}
                                    onClick={() => handleDialogClickOpen(sheds[tableMeta.rowIndex].mvmId, sheds[tableMeta.rowIndex].id)}>
                                    CheckIn
                                </Button>
                            );
                        }
                        else
                            return <div style={{ minWidth: 140 }}><span> </span></div>;

                    }

                }
            },
        },
        {
            name: 'shedCode',
            label: "GALPÃO",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }

        },
        {
            name: 'shedType',
            label: "Modalidade",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return <span style={{ minWidth: 10 }}>{value == 'D' ? 'Descarga' : 'Carga'}</span>;
                }
            }
        },
        {
            name: 'movementTypeDescription',
            label: "TIPO",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }

        },
        { //10
            name: 'checkInDate',
            label: "DATA/HORA CHECKIN",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: DataFormat
            }
        },
        {
            name: 'entryDate',
            label: "DATA/HORA ENTRADA",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: DataFormat
            }
        },
        {
            name: 'entryUserName',
            label: "NOME DO USUÁRIO",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
        {
            name: 'exitDate',
            label: "DATA/HORA SAÍDA",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: DataFormat
            }
        },
        {
            name: 'exitUserName',
            label: "NOME DO USUÁRIO",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        },
    ]

    const options = {
        textLabels: {
            body: {
                noMatch: _t('noMatch'),
                toolTip: "",
            },
            pagination: {
                next: _t("next"),
                previous: _t("previous"),
                rowsPerPage: _t("rowsPerPage") + ":",
                displayRows: _t("of"),
            }
        }
    }

    const formValidation = async (data: any) => {
        var result = false;
        clearErrors("shed");
        clearErrors("shedMovementType");
        try {
            const schema = Yup.object().shape({
                shed: Yup.object()
                    .nullable()
                    .required(tval("requiredField"))
                    .shape({
                        code: Yup.string().required(
                            tval("requiredField")
                        ),
                    }),
                shedMovementType: Yup.object()
                    .nullable()
                    .required(tval("requiredField"))
                    .shape({
                        code: Yup.string().required(
                            tval("requiredField")
                        ),
                    }),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            result = true;
        } catch (err) {
            var errors: string[] = [];

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    if (
                        errors.filter((element) =>
                            element.includes(error.message)
                        ).length === 0
                    )
                        errors.push(error.message);

                    setError(
                        error.path?.split(".")[0] as
                        | "shed"
                        | "shedMovementType",
                        { message: error.message }
                    );
                });

                errors.forEach((element) => {
                    if (element === tval("requiredField"))
                        enqueueSnackbar(_t("requiredFieldsValidation"), {
                            variant: "warning",
                        });
                    else enqueueSnackbar(element, { variant: "warning" });
                });
            }

            result = false;
        }

        return result;
    };

    const addItemOnList = async () => {
        var data = getValues();
        // return true;

        setCircularLoading(true);

        if (!(await formValidation(data))) return;
        var newValue: MvmShedRequest = {
            order: sheds.length + 1,
            companyId: user.company.companyID,
            mvmId: mvm?.id,
            shedId: Number(data.shed.code),
            shedCode: data.shed.label.split("-")[0]?.trim(),
            shedType: data.shed.shedType,
            movementTypeId: data.shedMovementType.code,
            movementTypeDescription: data.shedMovementType.label,
            tolerance: data.shedMovementType.tolerance
        };
        if (
            sheds.filter(
                (element: any) =>
                    element.shedCode === newValue.shedCode &&
                    element.movementTypeId === newValue.movementTypeId
            ).length > 0
        ) {
            setCircularLoading(false);
            enqueueSnackbar(tShed("shedAlreadyInserted"), {
                variant: "warning",
            });
            return;
        }

        try {
            const newSheds = await MvmApi.shedsSave(newValue);
            enqueueSnackbar(_t("returnSubmitEditFormSuccess"), {
                variant: "success",
            });

            await reloadShedList();

            setCircularLoading(false);

        } catch (err) {
            setCircularLoading(false);
        }
        setValue("shed", {});
        setValue("shedMovementType", {});

    };

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            }
        }
    })


    return (
        <Container maxWidth={false} component="main" style={{ marginLeft: -20 }}>

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog
                open={dialogOpen}
                onClose={handleDialogClickClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Atenção"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {"Deseja efetuar o CheckIn?"}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClickClose}>{"Cancelar"}</Button>
                    <Button onClick={() => handleConfirmation()} autoFocus>{"Confirmar"}</Button>
                </DialogActions>
            </Dialog>

            <form translate={undefined}>
                <MvmSummary
                    control={control}
                    name={"summary"}
                    onChange={onSummaryChange}
                    setValue={setValue}
                    showSearch={true}
                    mvmStatus={[
                        MvmStatus.FLAG_STATUS_PENDING_UNLOAD,
                        MvmStatus.FLAG_STATUS_PENDING_FINISH_UNLOAD,
                        MvmStatus.FLAG_STATUS_PENDING_LOAD,
                        MvmStatus.FLAG_STATUS_PENDING_FINISH_LOAD,
                        MvmStatus.FLAG_STATUS_PENDING_EXIT
                    ]}
                    includeProperties={["Sheds", "Invoices"]}
                     />

                {loading || mvm == null ? <></> :
                    <>
                        <PageTitle style={{ marginLeft: 10 }} title={"Check-In Manual"} />

                        <Grid container spacing={1}>
                            <SelectShedMovementType
                                nameSelectShed={"shed"}
                                nameSelectMovementType={"shedMovementType"}
                                control={control}
                                setValue={setValue}
                                showConfirmButton={true}
                                userName={user.userName}
                                onButtonClick={addItemOnList}
                            />
                        </Grid>

                        <Grid style={{ marginLeft: 10 }}>
                            <MuiThemeProvider theme={myTheme} >
                                <MUIDataTable
                                    title=""
                                    data={sheds}
                                    columns={columns}
                                    options={{
                                        ...options,
                                        serverSide: true,
                                        pagination: false,
                                        sort: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                    }}
                                />

                            </MuiThemeProvider>
                        </Grid>
                        <Grid style={{ paddingTop: 20 }}>
                            <ButtonUI onClick={() => props && props.setCheckinManual ? props.setCheckinManual(false) : null}>Voltar</ButtonUI>
                        </Grid>
                    </>}
            </form>
        </Container>
    )
}
export default CheckInManual;